import { format } from "date-fns";

export const safeFormat = (
    date: Date | null | undefined,
    formatStr = 'yyyy-MM-dd'
): string => {
    try {
        return date ? format(date, formatStr) : '';
    } catch {
        return '';
    }
};